<template>
  <div class="reviewHDDT">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="@/pages/contract/review/img/Nextpay-logo-white.svg" /></a>
        <h1>Xác nhận thông tin phụ lục hợp đồng</h1>
      </div>
    </div>
    <!-- Main -->
    <div class="main">
      <div class="title-main">
        <ul class="nav nav-tabs" role="tablist">
          <li v-if="!keyTab" class="nav-item" role="presentation">
            <button type="button" @click="keyTab = true" class="nav-link">
              <span><img src="@/pages/contract/review/img/tomtat.svg" /></span>
              Xem tóm tắt
            </button>
          </li>
          <li v-if="keyTab" class="nav-item" role="presentation">
            <button type="button" @click="keyTab = false" class="nav-link">
              <span><img src="@/pages/contract/review/img/xemhd.svg" /></span>
              {{ dataConfig.keyChild === 19 ? 'Xem chi tiết' : 'Xem phụ lục' }}
            </button>
          </li>
          <li class="nav-item" v-if="canBack">
            <button
              type="button"
              @click="$router.back()"
              class="nav-link text-danger ml-2"
              style="color: red !important"
            >
              Quay lại
            </button>
          </li>
        </ul>
        <div v-if="showAction" class="list-btn">
          <button
            v-if="dataAppendix && dataAppendix.state === 'SENT'"
            type="button"
            class="btn btn-primary btn-sm"
            @click="$emit('confirm', true)"
          >
            Xác nhận
          </button>
          <!-- <b-button
            v-if="dataAppendix && dataAppendix.state === 'SENT'"
            variant="primary"
            class="btn btn-primary btn-sm"
            @click="openPopup"
          >
            Xác nhận
          </b-button> -->
          <button
            v-if="dataAppendix && dataAppendix.state === 'SENT'"
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="$emit('confirm', false)"
          >
            Từ chối
          </button>
          <div
            v-if="
              dataAppendix &&
              (dataAppendix.state === 'WAITING_SIGN' ||
                dataAppendix.state === 'SIGNING' ||
                dataAppendix.state === 'SIGNED' ||
                dataAppendix.state === 'SIGNED_WAITING_APPROVED' ||
                dataAppendix.state === 'APPROVED' ||
                dataAppendix.state === 'REJECTED_SA')
            "
            class="btn btn-outline-success btn-sm"
            disabled=""
          >
            <i class="bx bxs-check-circle"></i>
            {{ dataConfig.keyChild === 19 ? 'Đã xác nhận - Chờ ký' : 'Đã xác nhận ' }}
          </div>
          <div
            v-if="dataAppendix && dataAppendix.state === 'REJECTED_MC'"
            class="btn btn-outline-danger btn-sm"
            disabled=""
          >
            <i class="bx bxs-minus-circle"></i> Đã từ chối
          </div>
        </div>
      </div>
      <div class="main-content">
        <div class="tab-content">
          <div v-if="keyTab">
            <contractSummary :dataContract="dataContract"></contractSummary>
            <appendixCredits :dataContract="dataContract"></appendixCredits>
            <appendixTrans :dataContract="dataContract"></appendixTrans>
            <appendixQr :dataContract="dataContract"></appendixQr>
            <appendixDevice :dataContract="dataContract"></appendixDevice>
            <appendixLinkCard :dataContract="dataContract"></appendixLinkCard>
            <appendixPackage :dataContract="dataContract"></appendixPackage>
            <appendixChangeInfo :dataContract="dataContract"></appendixChangeInfo>
            <appendixLiquid :dataContract="dataContract"></appendixLiquid>
            <appendixRecall :dataContract="dataContract"></appendixRecall>
            <appendixBG :dataContract="dataContract"></appendixBG>
            <appendixTransfer :dataContract="dataContract"></appendixTransfer>
            <appendixHomePayLater :dataContract="dataContract"></appendixHomePayLater>
            <appendixQrConnector :dataContract="dataContract"></appendixQrConnector>
            <contractSummary2
              :dataContract="dataContract"
              :dataAppendix="dataAppendix"
              :isView="dataConfig.keyChild === 19"
            ></contractSummary2>
          </div>
          <div v-if="!keyTab">
            <div
              v-if="
                dataContract.typeCustomer === 'COMPANY' &&
                businessStateView.includes(dataContract.state) &&
                srcPDF
              "
              class="tab-content"
            >
              <pdfViewer :url="srcPDF" />
            </div>
            <div v-else>
              <ul class="nav nav-tabs tab-child-list" role="tablist">
                <li class="nav-item">
                  <a class="active nav-link">
                    {{ dataConfig.title }}
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div v-if="dataConfig.keyChild === 2" :class="getActive(2)">
                  <contractTransQr
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                    v-if="isDeviceExsistQr(dataContract.lstAppendixDevices)"
                  ></contractTransQr>
                  <contractTrans
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                    v-else
                  ></contractTrans>
                </div>
                <div v-if="dataConfig.keyChild === 3" :class="getActive(3)">
                  <contractCredits
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractCredits>
                </div>
                <div
                  :class="getActive(4)"
                  v-if="dataConfig.keyChild === 4 && isDevice(dataContract.lstAppendixDevices)"
                >
                  <contractTapToPhone
                    v-if="isTapToPhone(dataContract.lstAppendixDevices)"
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractTapToPhone>
                  <contractDevice
                    v-else
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractDevice>
                </div>
                <div :class="getActive(5)" v-if="dataConfig.keyChild === 5">
                  <contractPackage
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractPackage>
                </div>

                <div v-if="dataConfig.keyChild === 6" :class="getActive(6)">
                  <contractLiquid
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractLiquid>
                </div>

                <div v-if="dataConfig.keyChild === 7" :class="getActive(7)">
                  <contractTransfer
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractTransfer>
                </div>
                <div :class="getActive(8)" v-if="dataConfig.keyChild === 8">
                  <contractCashback
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractCashback>
                </div>
                <div v-if="dataConfig.keyChild === 9" :class="getActive(9)">
                  <contractRecall
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractRecall>
                </div>

                <div v-if="dataConfig.keyChild === 10" :class="getActive(10)">
                  <contractBG :dataContract="dataContract" :appendix="dataAppendix"></contractBG>
                </div>
                <div v-if="dataConfig.keyChild === 11" :class="getActive(11)">
                  <contractQr :dataContract="dataContract" :appendix="dataAppendix"></contractQr>
                </div>
                <div v-if="dataConfig.keyChild === 12" :class="getActive(12)">
                  <contractLend
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractLend>
                </div>
                <div v-if="dataConfig.keyChild === 13" :class="getActive(13)">
                  <contractOnUs
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractOnUs>
                </div>
                <div v-if="dataConfig.keyChild === 14" :class="getActive(14)">
                  <contractChange
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractChange>
                </div>
                <div v-if="dataConfig.keyChild === 15" :class="getActive(15)">
                  <contractRents
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractRents>
                </div>
                <div v-if="dataConfig.keyChild === 16" :class="getActive(16)">
                  <contractHomePayLater
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractHomePayLater>
                </div>
                <div v-if="dataConfig.keyChild === 18" :class="getActive(18)">
                  <contractQrConnetor
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractQrConnetor>
                </div>
                <div v-if="dataConfig.keyChild === 17" :class="getActive(17)">
                  <contractLinkCard
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  ></contractLinkCard>
                </div>
                <div v-if="dataConfig.keyChild === 19" :class="getActive(19)">
                  <!-- 1. HỢP ĐỒNG THANH LÝ VIMO -->
                  <contractLiquidVimo
                    v-if="!isCompany"
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  />

                  <!-- 5. YÊU CẦU HỖ TRỢ CHUYỂN GIAO DỮ LIỆU -->

                  <contractTransferDataNl
                    v-if="!isCompany"
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  />

                  <!-- 2. HỢP ĐỒNG HỢP TÁC CHẤP NHẬN THANH TOÁN -->
                  <!-- <contractReviewQrNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    :dataAppendix="dataAppendix"
                    v-if="isDeviceExsistQrNl(dataContract.lstAppendixNganluongConverts)"
                    :isHiddenFilePdf="true"
                  /> -->
                  <contractReviewNl
                    :dataContract="dataContract"
                    :tableContactInfos="tableContactInfos"
                    :dataAppendix="dataAppendix"
                    :isHiddenFilePdf="true"
                  />

                  <!-- 3. PHỤ LỤC BIỂU PHÍ VÀ NGUYÊN TẮC CHẤP NHẬN THANH TOÁN -->
                  <!-- <contractTransQrNl
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                    v-if="isDeviceExsistQrNl(dataContract.lstAppendixNganluongConverts)"
                  /> -->
                  <contractTransNl :dataContract="dataContract" :appendix="dataAppendix" />

                  <!-- 4. PHỤ LỤC BẢO VỆ DỮ LIỆU CÁ NHÂN -->
                  <contractProtectPersonalNl
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  />

                  <!-- 6. BIÊN BẢN THỎA THUẬN KIỂM TRA THIẾT BỊ -->
                  <contractDeviceCheckNl :dataContract="dataContract" :appendix="dataAppendix" />
                  <contractCreditsNl
                    v-if="dataAppendix?.existingAppendixTypes?.includes('CREDIT')"
                    :dataContract="dataContract"
                    :appendix="dataAppendix"
                  />
                  <!-- v-if="isDeviceNl(dataContract.lstAppendixNganluongConverts)" -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <slot name="append-main"></slot>
      </div>
    </div>
    <footer class="mb-4" v-if="keyTab">
      <div class="footer-title">
        <p>
          <a href=""><img src="@/pages/contract/review/img/nextpay-logo.svg" alt="" /></a>
          Hỗ trợ thanh toán
        </p>
        <p>CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</p>
      </div>
      <ul class="footer-logo">
        <li>
          <a
            href="https://cdn.webrazzi.com/uploads/2013/12/redherring-global-winner.png"
            target="_blank"
            ><img src="@/pages/contract/review/img/global.png" alt=""
          /></a>
        </li>
        <li>
          <a
            href="https://www.sbv.gov.vn/webcenter/portal/vi/menu/trangchu/ttsk/ttsk_chitiet;jsessionid=Pkrwf92VGC5GdKySnvLJWgK5Hg5T6rv6BQK9G5lr8ZyK0DthZvwF!298591869!1655082551?centerWidth=80%25&amp;dDocName=SBVWEBAPP01SBV079234&amp;leftWidth=20%25&amp;rightWidth=0%25&amp;showFooter=false&amp;showHeader=false&amp;_adf.ctrl-state=9sau1ipwg_115&amp;_afrLoop=3971849221001628#%40%3F_afrLoop%3D3971849221001628%26centerWidth%3D80%2525%26dDocName%3DSBVWEBAPP01SBV079234%26leftWidth%3D20%2525%26rightWidth%3D0%2525%26showFooter%3Dfalse%26showHeader%3Dfalse%26_adf.ctrl-state%3Dyj4aegj4q_4"
            target="_blank"
            ><img src="@/pages/contract/review/img/icon-hh.png" alt=""
          /></a>
        </li>
      </ul>
    </footer>

    <!-- Popup component -->
    <!-- <PopupConfirmNganLuong
      ref="popupRef"
      :id="appendixId"
      :email="email"
      :mobile="mobile"
      @hide="onPopupHide"
    /> -->
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  // import PopupConfirmNganLuong from '@/pages/nganluong/popup-confirm/index.vue'
  import appendixCredits from '@/components/contracts/appendix-component/appendix-credits.vue'
  import appendixTrans from '@/components/contracts/appendix-component/appendix-trans.vue'
  import appendixDevice from '@/components/contracts/appendix-component/appendix-devices.vue'
  import appendixLinkCard from '@/components/contracts/appendix-component/appendix-link-card.vue'
  import appendixQr from '@/components/contracts/appendix-component/appendix-qr.vue'
  import appendixPackage from '@/components/contracts/appendix-component/appendix-package.vue'
  import appendixChangeInfo from '@/components/contracts/appendix-component/appendix-info.vue'
  import appendixLiquid from '@/components/contracts/appendix-component/appendix-liquid.vue'
  import appendixRecall from '@/components/contracts/appendix-component/appendix-recall.vue'
  import appendixBG from '@/components/contracts/appendix-component/appendix-bg.vue'
  import appendixTransfer from '@/components/contracts/appendix-component/appendix-transfer.vue'
  import appendixHomePayLater from '@/components/contracts/appendix-component/appendix-home-pay-later.vue'
  import appendixQrConnector from '@/components/contracts/appendix-component/appendix-qr-connector.vue'

  import contractTrans from '@/components/contracts/appendix/contract-trans.vue'
  import contractTransQr from '@/components/contracts/appendix/contract-trans-qr.vue'
  import contractCredits from '@/components/contracts/appendix/contract-credits.vue'
  import contractCreditsNl from '@/components/contracts/appendix/contract-credits-nl.vue'
  import contractDevice from '@/components/contracts/appendix/contract-device.vue'
  import contractTapToPhone from '@/components/contracts/appendix/contract-tap-to-phone.vue'
  import contractCashback from '@/components/contracts/appendix/contract-cashback.vue'
  import contractPackage from '@/components/contracts/appendix/contract-package-v2/index.vue'
  import contractLiquid from '@/components/contracts/appendix/contract-liquid.vue'
  import contractRecall from '@/components/contracts/appendix/contract-recall.vue'
  import contractBG from '@/components/contracts/appendix/contract-bg.vue'
  import contractQr from '@/components/contracts/appendix/contract-qr.vue'
  import contractLend from '@/components/contracts/appendix/contract-lend.vue'
  import contractOnUs from '@/components/contracts/appendix/contract-on-us.vue'
  import contractChange from '@/components/contracts/appendix/contract-change.vue'
  import contractTransfer from '@/components/contracts/appendix/contract-transfer.vue'
  import contractSummary from '@/components/contracts/others-component/contract-summary.vue'
  import contractSummary2 from '@/components/contracts/others-component/contract-summary2.vue'
  import pdfViewer from '@/pages/contract/review/PDFViewer'
  import contractRents from '../../../../components/contracts/appendix/contract-rents.vue'
  import contractHomePayLater from '@/components/contracts/appendix/contract-home-pay-later.vue'
  import contractQrConnetor from '@/components/contracts/appendix/contract-qr-connetor.vue'
  import contractLinkCard from '@/components/contracts/appendix/contract-linkcard.vue'

  import contractReviewNl from '@/components/contracts/appendix/contract-review-nl.vue'
  // import contractReviewQrNl from '@/components/contracts/appendix/contract-review-qr-nl.vue'
  import contractLiquidVimo from '@/components/contracts/appendix/contract-liquid-vimo.vue'
  import contractTransNl from '@/components/contracts/appendix/contract-trans-nl.vue'
  // import contractTransQrNl from '@/components/contracts/appendix/contract-trans-qr-nl.vue'
  import contractProtectPersonalNl from '@/components/contracts/appendix/contract-protect-personal-nl.vue'
  import contractTransferDataNl from '@/components/contracts/appendix/contract-transfer-data-nl.vue'
  import contractDeviceCheckNl from '@/components/contracts/appendix/contract-device-check-nl.vue'

  export default {
    props: {
      dataContract: {
        type: Object,
      },
      dataAppendix: {
        type: Object,
      },
      dataConfig: {
        type: Object,
      },
      srcPDF: {
        type: String,
        default: null,
      },
      canBack: {
        type: Boolean,
        default: false,
      },
      showAction: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        keyTab: false,
        businessStateView: Config.businessStateView,
        tableContactInfos: [],
      }
    },

    components: {
      appendixCredits,
      appendixTrans,
      appendixQr,
      appendixDevice,
      appendixLinkCard,
      appendixPackage,
      appendixChangeInfo,
      appendixLiquid,
      appendixRecall,
      appendixBG,
      appendixTransfer,
      appendixHomePayLater,
      appendixQrConnector,
      contractTrans,
      contractTransQr,
      contractCredits,
      contractDevice,
      contractTapToPhone,
      contractCashback,
      contractPackage,
      contractLiquid,
      contractRecall,
      contractTransfer,
      contractSummary,
      contractSummary2,
      contractBG,
      contractQr,
      contractLend,
      contractHomePayLater,
      contractQrConnetor,
      contractLinkCard,
      contractOnUs,
      contractChange,
      pdfViewer,
      contractRents,
      contractReviewNl,
      // contractReviewQrNl,
      contractLiquidVimo,
      contractTransNl,
      // contractTransQrNl,
      contractProtectPersonalNl,
      contractTransferDataNl,
      contractDeviceCheckNl,
      contractCreditsNl,
      // PopupConfirmNganLuong,
    },
    computed: {
      appendixId() {
        return this.dataAppendix?.appendixId || this.dataAppendix?._id || ''
      },
      email() {
        return this.dataContract?.customerInfoCommon?.email || ''
      },
      mobile() {
        return this.dataContract?.customerInfoCommon?.mobile || ''
      },
      isCompany() {
        return (
          this.dataContract?.typeCustomer === 'COMPANY' ||
          this.dataContract?.customerInfoCommon?.customerType === 'COMPANY'
        )
      },
    },
    created() {
      this.getConfigSystem()
    },
    methods: {
      getConfigSystem() {
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              const config = data.data
              this.tableContactInfos = config.tableContactInfos
            }
          })
          .catch(error => console.log(error))
      },
      // openPopup() {
      //   if (this.$refs.popupRef) {
      //     this.$refs.popupRef.show()
      //   }
      // },
      onPopupHide(isSuccess) {
        if (isSuccess) {
          this.$emit('confirm', true)
        }
      },
      getActive(value) {
        if (this.dataConfig.keyChild === value) return 'active'
      },
      hasAppendix(arr) {
        return arr?.find(s => s.isCreatedWithContract)
      },
      isCashback(arr) {
        return arr.find(s => s.appendixDevice.isCashback === true && s.isCreatedWithContract)
      },
      isDevice(arr) {
        const appendix = arr.find(s => s.isCreatedWithContract !== true)
        if (appendix) {
          const map =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.reduce((arr, current) => {
                  arr.push(current.name)

                  return arr
                }, [])
              : []

          if (map.length > 0) {
            if (map.includes('ONBOARD_QR') && map.length == 1) {
              return false
            }

            if (map.includes('ONBOARD_QR') && map.length > 1) {
              let flag = false
              map.map(item => {
                if (item != 'ONBOARD_QR') {
                  flag = true
                }
              })

              return flag
            }
          }
        }

        if (!appendix) {
          return false
        }

        return true
      },
      // isDeviceNl(arr) {
      //   if (!arr || !arr.length) return false
      //   const appendix = arr.find(
      //     s =>
      //       s.appendixNganluongConvert &&
      //       s.appendixNganluongConvert.isCashback !== true &&
      //       s.appendixNganluongConvert.isLend !== true &&
      //       s.appendixNganluongConvert.isRent !== true &&
      //       s.isCreatedWithContract
      //   )
      //   if (appendix) {
      //     const map =
      //       appendix.appendixNganluongConvert && appendix.appendixNganluongConvert.deviceInfos
      //         ? appendix.appendixNganluongConvert.deviceInfos.reduce((arr, current) => {
      //             arr.push(current.name)
      //             return arr
      //           }, [])
      //         : []

      //     if (map.length > 0) {
      //       if (map.includes('ONBOARD_QR') && map.length == 1) {
      //         return false
      //       }
      //       if (map.includes('ONBOARD_QR') && map.length > 1) {
      //         let flag = false
      //         map.forEach(item => {
      //           if (item != 'ONBOARD_QR') flag = true
      //         })
      //         return flag
      //       }
      //     }
      //   }
      //   if (!appendix) return false
      //   return true
      // },
      isDeviceExsistQrNl(arr) {
        if (!arr || !arr.length) return false
        let flag = false
        const appendix = arr.find(
          s =>
            s.appendixNganluongConvert &&
            s.appendixNganluongConvert.isCashback !== true &&
            s.appendixNganluongConvert.isLend !== true &&
            s.isCreatedWithContract
        )
        if (appendix) {
          const deviceInfo =
            appendix.appendixNganluongConvert && appendix.appendixNganluongConvert.deviceInfos
              ? appendix.appendixNganluongConvert.deviceInfos.find(
                  item => item.name == 'ONBOARD_QR'
                )
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }
        return flag
      },
      isDeviceExsistQr(arr) {
        let flag = false

        const appendix = arr.find(s => s.isCreatedWithContract !== true)

        if (appendix) {
          const deviceInfo =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.find(item => item.name == 'ONBOARD_QR')
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }

        return flag
      },
      isTapToPhone(arr) {
        let flag = false

        const appendix = arr.find(s => s.isCreatedWithContract !== true)

        if (appendix) {
          const deviceInfo =
            appendix.appendixDevice && appendix.appendixDevice.deviceInfos
              ? appendix.appendixDevice.deviceInfos.find(item => item.name == 'TAP_2_PHONE')
              : {}
          if (deviceInfo && Object.keys(deviceInfo).length > 0) {
            flag = true
          }
        }

        return flag
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
